var _path, _circle, _circle2, _circle3, _circle4, _path2, _text, _text2, _text3, _text4, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlgoBlobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bodyGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4FD1C5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#38B2AC",
      stopOpacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 100 Q30 30 100 30 Q170 30 170 100 Q170 170 100 170 Q30 170 30 100 Z",
    fill: "url(#bodyGradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 90,
    r: 15,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 90,
    r: 15,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 90,
    r: 7,
    fill: "#2C7A7B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 90,
    r: 7,
    fill: "#2C7A7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 130 Q100 150 130 130",
    fill: "none",
    stroke: "#2C7A7B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 50,
    fontFamily: "monospace",
    fontSize: 12,
    fill: "#2C7A7B"
  }, "10")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 50,
    fontFamily: "monospace",
    fontSize: 12,
    fill: "#2C7A7B"
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 160,
    fontFamily: "monospace",
    fontSize: 12,
    fill: "#2C7A7B"
  }, "01")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 160,
    fontFamily: "monospace",
    fontSize: 12,
    fill: "#2C7A7B"
  }, "10")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 100 Q20 90 25 70 Q30 50 40 60",
    fill: "none",
    stroke: "#2C7A7B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160 100 Q180 90 175 70 Q170 50 160 60",
    fill: "none",
    stroke: "#2C7A7B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgoBlobIcon);
export default __webpack_public_path__ + "static/media/AlgoBlobIcon.100af2d3d938abe7948e11e74eb0eb48.svg";
export { ForwardRef as ReactComponent };